import React from 'react';
import { Wrap, Logo, Name, Mind } from './styled';

const Container = () => (
    <Wrap>
        <Logo />
        <Name>0316 Company</Name>
        <Mind>Reliance / Relaxed / Remember</Mind>
    </Wrap>
);

export default Container;
